/*
    Description: class for loading more cards
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/

// import utility
import Utility from "../inc/utility";

// extend utility class
class Loadmore extends Utility{

    // constructor
    constructor({
        cardClass = null,
        cardWrapperClass = null,
        loadButtonClass = null,
        nonceClass = null,
        loadClass = null,
        hideClass = null,
    }={}){

        // extend class
        super();
        
        //get load more class name
        this.loadMoreButtonClass = loadButtonClass;

        // get card wrapper
        this.wrapper = cardWrapperClass;

        // get load more button class
        this.loadButtons = document.querySelectorAll(`.${this.loadMoreButtonClass}`);

        // init current loadmore bttn grandparent
        this.loadMoreGrandParent = null;

        // get cards
        this.cards = cardClass; 

        // get nonce
        this.nonce = nonceClass;

        // ajax process state
        this.progress = false;

        // ajax loading
        this.loading = loadClass;

        // hide class
        this.hide = hideClass;

        // run event
        this.events();

    }

    // all events
    events(){

        // check for bttns
        if(this.loadButtons){

            // LOOP: load more bttns
            for(const bttn of this.loadButtons){
                
                //add event listner 
                bttn.addEventListener("click", this.process.bind(this));
                
            }

        }

    }
    
    // process click 
    process(e){
        
        // prevent default
        e.preventDefault();

        // check if ajax has been called 
        if(this.progress) return;

        // set this to self
        const self = this,

        // bttn
        bttn = e.target,

        // wrapper
        wrapper = (bttn.closest(`.${self.wrapper}`) || bttn.parentNode.parentNode.parentNode.querySelector(`.${self.wrapper}`)),

        // cards
        cards = (wrapper) ? wrapper.querySelectorAll(`.${self.cards}`) : null,

        // get nonce
        nonce = bttn.parentNode.querySelector(`.${self.nonce}`),

        // portal
        portal = bttn.dataset.port,

        // type
        type = bttn.dataset.type,

        // next batch
        batch = bttn.dataset.num,

        // get cta
        cta = bttn.dataset.cta,

        // set form data
        form = new FormData();

        // progress started
        self.progress = true;

        // update form data
        if(form && portal) form.append('portal', portal);
        if(form && type) form.append('type', type);
        if(form && batch) form.append('limit', batch);
        if(form && cta) form.append("cta", cta);
        if(form && cards) form.append("count", cards.length);
        if(form && nonce) form.append('nonce', nonce.value);

        // add loading gif
        bttn.classList.add(self.loading);

        // set current load more bttn parent
        self.loadMoreGrandParent = bttn.parentNode.parentNode;

        // ajax call
        self.ajax({
            
            // send data
            data:form,
            
            // url
            action:"load-more",
            
        // promise results 
        }).then((results) => {

            // remove loading gif
            bttn.classList.remove(self.loading);

            // get results and add cards
            if(results.success) self.card(wrapper, bttn, results.success);

            // check if total card(s) width is more than wrapper width - if so show gui otherwise hide gui
            self.checkSize(wrapper);

            // reset progress
            self.progress = false;

        // catch error
        }).catch((err) => {
            
            // remove loading gif
            bttn.classList.remove(self.loading);

            // reset progress
            self.progress = false;

            // display error
            console.log(err);

        });

    }

    // add card
    card(wrapper = null, bttn = null, data = null){

        // end case
        if(!wrapper || (!wrapper == null) || !bttn || (!bttn == null) || !data || (data == null)) return;

        // init loadMoreBttn button
        let removeLoadMoreBttn = false;

        // LOOP: thru data to generate card(s)
        for(const card of data){
            
            // init data - img
            const img = card.img,
            
            // date
            date = card.date,
            
            // title
            title = card.title,

            // preview content
            content = card.content,

            // main cta (read more cta copy)
            cta = card.cta,

            // secondary (download cta copy)
            cta2 = card.cta2,

            // file URL
            file = card.file,

            // get link URL
            link = card.link, 
            
            // get external status
            external = card.external,
            
            // set card type
            type = card.type;

            // build card
            this.buildCard(wrapper, {
                "img":img,
                "date":date,
                "title":title,
                "content":content,
                "cta":cta,
                "cta2":cta2,
                "file":file,
                "link":link,
                "external":external,
                "type":type
            });

            // set loadMoreBttn switch
            if(!removeLoadMoreBttn && card.remove) removeLoadMoreBttn = true;

        }

        // remove load more bttn
        if(removeLoadMoreBttn && bttn && bttn.parentNode) bttn.parentNode.remove();

    }

    // build card
    buildCard(parentWrapper = null, data = null){
        
        // end case
        if(!parentWrapper || (parentWrapper === null) || (typeof data !== 'object') || (data === null)) return;
 
        // create elements
        const wrapper = document.createElement("div"),
        img = document.createElement("div"),
        date = document.createElement("p"),
        header = document.createElement("h2"),
        content = document.createElement("div"),
        linkWrapper = document.createElement("div"),
        link1 = document.createElement("a"),
        link2 = document.createElement("a"),
        screenSpan = document.createElement("span"),
        screenSpan2 = document.createElement("span"),
        kids = parentWrapper.children;

        // init optional subwrapper
        let subwrapper = null;

        // check card type - create subwrapper
        if(data.type.toLowerCase() === "post") subwrapper = document.createElement("div");

        // add classes
        wrapper.classList.add("ajaxcard", "--js-card");
        if(subwrapper !== null) subwrapper.classList.add("ajaxcard__wrapper");
        img.classList.add("ajaxcard__img");
        (subwrapper !== null) ? date.classList.add("ajaxcard__wrapper__date") : date.classList.add("ajaxcard__date");
        (subwrapper !== null) ? header.classList.add("ajaxcard__wrapper__header") : header.classList.add("ajaxcard__header");
        (subwrapper !== null) ? content.classList.add("ajaxcard__wrapper__content") : content.classList.add("ajaxcard__content");
        (subwrapper !== null) ? linkWrapper.classList.add("ajaxcard__wrapper__links") : linkWrapper.classList.add("ajaxcard__links");
        (subwrapper !== null) ? link1.classList.add("ajaxcard__wrapper__links__link") : link1.classList.add("ajaxcard__links__link");
        (subwrapper !== null) ? link2.classList.add("ajaxcard__wrapper__links__link") : link2.classList.add("ajaxcard__links__link");
        screenSpan.classList.add("screen-reader");
        screenSpan2.classList.add("screen-reader");

        // add attributes
        wrapper.setAttribute("tabindex", 0);
        // header.setAttribute("tabindex", 0);
        // content.setAttribute("tabindex", 0);

        // glue'm up
        wrapper.appendChild(img);
        if(subwrapper !== null) wrapper.appendChild(subwrapper);
        (subwrapper !== null) ? ((data.date) ? subwrapper.appendChild(date) : null) : ((data.date) ? wrapper.appendChild(date) : null);
        (subwrapper !== null) ? subwrapper.appendChild(header) : wrapper.appendChild(header);
        (subwrapper !== null) ? subwrapper.appendChild(content) : wrapper.appendChild(content);
        (subwrapper !== null) ? subwrapper.appendChild(linkWrapper) : wrapper.appendChild(linkWrapper);

        // add content
        if(data.img) img.innerHTML = data.img;
        if(data.date) date.innerText = data.date;
        if(data.title){
            header.innerText = data.title;
            screenSpan.textContent = `: ${data.title}`;
        } 
        if(data.content) content.innerHTML = data.content;
        
        // add link one - check for copy and url
        if(data.cta && data.link){

            //add copy
            link1.textContent = data.cta;

            // add url
            link1.setAttribute("href", data.link);

            // check if self ot external
            (data.external) ? link1.setAttribute("target", "_blank") : link1.setAttribute("target", "_self");

            // add aria
            link1.setAttribute("aria-description", `Learn more about: ${data.title}`);

            // add span link
            link1.appendChild(screenSpan);

            // add link to link wrapper
            linkWrapper.appendChild(link1);
            
        }
        
        // add link two - check for copy and file url
        if(data.cta2 && data.file){
            
            //add copy
            link2.textContent = data.cta2;

            // add url
            link2.setAttribute("href", data.file);
            
            // set link target
            link2.setAttribute("target", "_self");

            // set download attr
            link2.setAttribute("download", "");
            
            // add aria
            link2.setAttribute("aria-description", `Learn more about: ${data.title}`);
            
            // add span link
            link2.appendChild(screenSpan2);

            // add link to link wrapper
            linkWrapper.appendChild(link2);

        }
        
        //BLOG POSTS: insert cards before load more button
        if((data.type == "post") && (kids.length > 0)){
            
            // insert cards before load more button (last child of parentwrapper)
            parentWrapper.insertBefore(wrapper, kids[kids.length - 1]);

        // EVERYTHING ELSE
        }else{
            
            // add to parent card wrapper
            parentWrapper.appendChild(wrapper);

        }

        // return
        return;
        
    }

    // check card - hide and show
    checkSize(parent = null){

        // end case
        if(!parent || (parent == null)) return;
        
        // wrapper
        const wrapper = parent, 

        // get wrapper width
        wrapperWidth = parent.getBoundingClientRect()['width'],

        // cards
        cards = wrapper.children,
        
        // gap 
        gap = (((window.getComputedStyle(wrapper)["gap"] || "0").replace("px", "") * 1) * cards.length),

        // card width
        cardsWidth = (((cards && cards[0]) ? cards[0].getBoundingClientRect()['width'] : null) * cards.length);
    
        // skip if we dont have a grandparent
        if(this.loadMoreGrandParent == null) return;

        // hide/show
        ((cardsWidth + gap) > wrapperWidth) ? this.loadMoreGrandParent.children[0].classList.remove(this.hide) : this.loadMoreGrandParent.children[0].classList.add(this.hide);       

        // return
        return;

    }

}

// export module
export default Loadmore;